
<h2 mat-dialog-title>{{data.message}}</h2>
<div [ngSwitch]="data.infoType" class="info-container">
  <div *ngSwitchCase="'success'" class="info-ico">
    <span class="material-icons-round success">
      check_circle_outline
    </span>
  </div>
  <div *ngSwitchCase="'warning'" class="info-ico">
    <span class="material-icons-round warning">
      warning
    </span>
  </div>
  <div *ngSwitchCase="'error'" class="info-ico">
    <span class="material-icons-round error">
      error
    </span>
  </div>
  <div *ngSwitchDefault>
    
  </div>
</div>
<ng-template #warning_template></ng-template>

<mat-dialog-content></mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button class="btn-popup" [mat-dialog-close]="true" color="primary">OK</button>
</mat-dialog-actions> 
